exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.sellerPickerHolder[data-v-dec76728] {\n  position: relative;\n  z-index: 10;\n}\n.sellerPickerHolder .multiselect__select[data-v-dec76728] {\n    top: 8px !important;\n}\n.sellerPickerHolder .multiselect__tags[data-v-dec76728] {\n    background: none !important;\n    border: 0 !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-dec76728","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/tools/TeamMemberPicker.vue
// module id = 1966
// module chunks = 0